// extracted by mini-css-extract-plugin
export default {"box":"_1q84Uv0uQQ","visible":"_2x6NMshvmv","micro":"_6XCCkXfyJ7","inline":"UpScVedsx5","spinner":"_10DuCiKdUF","bar":"_227feOSxKK","circle":"_2AQCuHRTXn","rotate":"_2pRXvLbw-M","stop":"_2oyLaU9flW","faded":"_3R5V5irtt8","message":"_1ujRQcr1A8","center":"_3hosRxomrv","small":"_1upEEu6vBQ"};
    if(module.hot) {
      // 1633091598921
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  